// extracted by mini-css-extract-plugin
export var leftAlign = "_1q-2";
export var popper = "_1q-0";
export var subtitle = "_1q-1";